import { gql } from "@apollo/client";

export const Carrier_FIELDS = gql`
    fragment CarrierFields on TmsCarrierType {
      id
      carrierCode
      carrierName
      contactName
      contactPhone
      carrierType
      centerWarehouseIds
      status
      createdAt
      updatedAt
    }
`;

export interface CarrierType {
    id?: string;
    carrierCode: string;
    carrierName: string;
    contactName?: string;
    contactPhone?: string;
    carrierType?: number;
    centerWarehouseIds: string[];
    status: number;
    createdAt?: string;
    updatedAt?: string;
}